import { spacing } from './spacing';

export const semantic_spacing = {
  helper_text: {
    gap: {
      desktop: '6px',
      mobile: '6px',
    },
  },
  content: {
    gap_medium: {
      desktop: spacing.spacing_6,
      mobile: spacing.spacing_4,
    },
    gap_small: {
      desktop: spacing.spacing_4,
      mobile: spacing.spacing_2,
    },
  },
  section: {
    margin: {
      desktop: spacing.spacing_4,
      mobile: spacing.spacing_0,
    },
    gap: {
      desktop: spacing.spacing_4,
      mobile: spacing.spacing_0,
    },
    padding_horizontal: {
      desktop: spacing.spacing_6,
      mobile: spacing.spacing_4,
    },
    padding_vertical: {
      desktop: spacing.spacing_6,
      mobile: spacing.spacing_6,
    },
  },
  table: {
    padding_large: {
      desktop: spacing.spacing_4,
      mobile: spacing.spacing_4,
    },
    padding_medium: {
      desktop: spacing.spacing_3,
      mobile: spacing.spacing_3,
    },
    padding_small: {
      desktop: spacing.spacing_2,
      mobile: spacing.spacing_2,
    },
    padding_xsmall: {
      desktop: spacing.spacing_1,
      mobile: spacing.spacing_1,
    },
  },
  empty_state: {
    padding: {
      desktop: spacing.spacing_30,
      mobile: spacing.spacing_30,
    },
  },
};
